// ============================================================================
// PairsForm — urls.ts : les quatre niveaux d'URL du client, source UNIQUE
// ============================================================================
// Modèle canonique §8.1 (GO FX 2026-10-13, détails D1-D8 du 2026-10-18) :
//   /                 public (catalogues, tunnel, pages à jeton — inchangé, D7)
//   /mon-espace       niveau PERSONNEL : la personne et ses casquettes
//   /o/:slug          niveau ORGANISATION : l'org dans l'URL (D2) — le slug de
//                     l'org, à défaut son id (N253 : slug nullable)
//   /plateforme       niveau PLATEFORME : vues transversales des pilotes Cecodev
//
// Lot 9.6 (2026-10-18, D8) : ces préfixes et constructeurs PURS sont partagés
// entre le client (`lib/urls.ts`, qui y ajoute l'org courante du jeton) et le
// serveur (`utils/liens-client.ts`, qui y ajoute l'origine `APP_URL` pour les
// emails, documents et notifications). Un lien serveur et un lien client vers
// la même page ont ainsi UNE définition. Les portes `/groupes/:id` et
// `/groupes/:g/seances/:s` (lot 9.1) résolvent l'org et le mode côté client :
// c'est l'adresse à donner quand on ne connaît pas l'org du groupe.
// ============================================================================
export const PREFIXE_MON_ESPACE = "/mon-espace";
export const PREFIXE_PLATEFORME = "/plateforme";
export const PREFIXE_ORG = "/o";
/** Chemin du niveau personnel : `cheminMonEspace("/inscriptions")` → `/mon-espace/inscriptions`. */
export function cheminMonEspace(chemin = "") {
    return `${PREFIXE_MON_ESPACE}${chemin}`;
}
/** Chemin du niveau plateforme : `cheminPlateforme("/pipeline")` → `/plateforme/pipeline`. */
export function cheminPlateforme(chemin = "") {
    return `${PREFIXE_PLATEFORME}${chemin}`;
}
/** Chemin du niveau organisation : `cheminOrg("client-x", "/projets")` → `/o/client-x/projets`. */
export function cheminOrg(segment, chemin = "") {
    return `${PREFIXE_ORG}/${segment}${chemin}`;
}
/** Segment d'URL d'une organisation : son slug, à défaut son id (N253). */
export function segmentOrg(slug, id) {
    return slug || id || null;
}
/** Un segment d'org qui est en fait un identifiant (org sans slug) — le switch l'envoie comme tel. */
export function segmentEstIdentifiant(segment) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment);
}
export function estCheminOrg(pathname) {
    return pathname.startsWith(`${PREFIXE_ORG}/`);
}
/** `/o/client-x/projets/42` → `/projets/42` ; `/o/client-x` → `""` ; hors niveau organisation → `null`. */
export function cheminSansOrg(pathname) {
    if (!estCheminOrg(pathname))
        return null;
    const reste = pathname.slice(PREFIXE_ORG.length + 1);
    const i = reste.indexOf("/");
    return i === -1 ? "" : reste.slice(i);
}
/**
 * Chemins où le sélecteur d'organisation n'a pas de sens : le niveau personnel,
 * les catalogues publics et le tunnel d'inscription (parcours personnel même
 * connecté).
 */
export const PREFIXES_PERSONNELS = [PREFIXE_MON_ESPACE, "/catalogue", "/plateforme/inscription"];
export function estCheminPersonnel(pathname) {
    return PREFIXES_PERSONNELS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
/**
 * Porte d'un groupe (lot 9.1, `GroupeHomeResolver`) : le client résout l'org et
 * le mode, puis mène à LA page groupe (`/o/:slug/groupes/:id`) ou à la vue
 * participant (`/mon-espace/groupes/:id`) selon la casquette. `suffixe` =
 * chaîne de requête (`?tab=seances`), transmise telle quelle.
 */
/** Page PUBLIQUE de vérification d'un document émis par la plateforme (QR code
 *  + code de vérification de l'attestation de supervision, lot K 2026-10-27). */
export const PREFIXE_VERIFICATION = "/verifier";
export function cheminVerificationDocument(code) {
    return `${PREFIXE_VERIFICATION}/${encodeURIComponent(code)}`;
}
export function cheminPorteGroupe(groupeId, suffixe = "") {
    return `/groupes/${groupeId}${suffixe}`;
}
/** Porte d'une séance (lot 9.3) : résolue vers `/o/:slug/groupes/:g/seances/:s`. */
export function cheminPorteSeance(groupeId, seanceId) {
    return `/groupes/${groupeId}/seances/${seanceId}`;
}
//# sourceMappingURL=urls.js.map